module.exports = __webpack_public_path__ + "static/media/icon-jewelry.b2b3fef3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/icon-jewelry.svg
// module id = 996
// module chunks = 0